module.exports = __webpack_public_path__ + "img/18.c028f040.png";